import { Injectable } from '@angular/core';
import { DataAccessService } from '@tripointe/tripointe-cms/data-access';
import { Breadcrumb, TabWithDropdown } from '@tripointe/tripointe-cms/types';
import { BehaviorSubject, combineLatest, Observable, ReplaySubject } from 'rxjs';

const generateEmptyTabWithDropdownEntity = (name: string): BehaviorSubject<TabWithDropdown> => {
  return new BehaviorSubject({
    name,
    statsCount: null,
    archived: false
  });
};

@Injectable({
  providedIn: 'root'
})
export class ContactsNavigationService {
  loading$ = new BehaviorSubject(false);

  entityListStatsCounts: Record<string, BehaviorSubject<TabWithDropdown>> = null;

  entityListArchivedStatuses: Record<string, ReplaySubject<boolean>> = null;

  constructor(private dataAccess: DataAccessService) {
    this.entityListStatsCounts = {
      contacts: generateEmptyTabWithDropdownEntity('contacts'),
      vendors: generateEmptyTabWithDropdownEntity('vendors'),
      types: generateEmptyTabWithDropdownEntity('types')
    };

    this.entityListArchivedStatuses = {
      contacts: new ReplaySubject(1),
      vendors: new ReplaySubject(1),
      types: new ReplaySubject(1)
    };
  }

  setLoading(isLoading: boolean): void {
    this.loading$.next(isLoading);
  }

  getDropdownDataCounts(): Observable<TabWithDropdown[]> {
    return combineLatest([
      this.getEntityListStatsCount('contacts'),
      this.getEntityListStatsCount('types'),
      this.getEntityListStatsCount('vendors')
    ]);
  }

  getEntityListStatsCount(name: string): Observable<TabWithDropdown> {
    return this.entityListStatsCounts[name].asObservable();
  }

  setEntityListStatsCount(name: string, newStats: TabWithDropdown): void {
    this.entityListStatsCounts[name].next(newStats);
  }

  setEntityListArchivedStatus(name: string, newStatus: boolean): void {
    this.entityListArchivedStatuses[name].next(newStatus);
  }

  getEntityListArchivedStatus(name: string): Observable<boolean> {
    return this.entityListArchivedStatuses[name].asObservable();
  }
}
